// extracted by mini-css-extract-plugin
export default {"root":"Home_root__195t6","label":"Home_label__sNw-9"};